interface NextArrowProps {
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
  classArrow?: string;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

import { _t } from "content";
import "../style.scss";

export function NextArrow({ className, onClick, style, classArrow, onMouseEnter, onMouseLeave }: NextArrowProps) {
  return (
    <div className={className} style={{ ...style }} onClick={onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <svg
        className={classArrow ? classArrow : "next-arrow-home"}
        xmlns="http://www.w3.org/2000/svg"
        width="60"
        height="70"
        viewBox="0 0 63.88 103.804"
        fill={_t.color1}
      >
        <g
          id="Grupo_482"
          data-name="Grupo 482"
          transform="translate(-2404.913 -1185.958) rotate(-135)"
        >
          <rect
            id="Retângulo_1560"
            data-name="Retângulo 1560"
            width="16.939"
            height="73.401"
            rx="8.469"
            transform="translate(-2621 797)"
          />
          <rect
            id="Retângulo_1561"
            data-name="Retângulo 1561"
            width="73.401"
            height="16.939"
            rx="8.469"
            transform="translate(-2621 853.462)"
          />
        </g>
      </svg>
    </div>
  );
}
